<form [formGroup]="markForm">
  <div class="row">
    <div class="col-md-6">
      <label for="posiz-timbro-lbl" class="font-weight-bold">Posizione del Timbro</label>
      <select id="posiz-timbro-lbl" class="form-control custom-select" formControlName="posizioneTimbro">
        <option value="alto">Orizzontale in alto a sinistra</option>
        <option value="basso">Orizzontale in basso a sinistra</option>
        <option value="sinistra">Verticale a sinistra</option>
        <option value="destra">Verticale a destra</option>
      </select>
    </div>

    <div class="col-md-6">
      <label class="font-weight-bold">Pagine da timbrare</label>
      <p class="active singlecheckbox radiobutton dati_generali">
        <input type="radio" id="tuttePagine" formControlName="tipoPagina" name="tuttePagine" value="tutte" />
        <label class="custom-control-label" for="tuttePagine">Tutte le pagine</label>    

        <input type="radio" id="paginaSpecificata" formControlName="tipoPagina" name="tipoPagina" value="specifica" />
        <label class="custom-control-label" for="paginaSpecificata">Pagina specifica</label>      
      </p>
    </div>
  </div>

  <div class="row" *ngIf="markForm.get('tipoPagina').value === 'specifica'">
    <div class="col-sm-5 col-xs-offset-5 col-sm-offset-6">
      <div naturalNumberInput
        formControlName="paginaSelezionata"
        [checkFormat]="true" 
        [allowNegative]="false" 
        [mandatory]="true"
        [minValue]="1" [type]="'number'"
        [labelInput]="'Numero pagina'">
      </div>
    </div>
  </div>

  <div class="standardpanel">
    <div class="row">
      <div class="col-sm-4 col-xs-4 col-xs-offset-8 col-sm-offset-8">
        <button type="button" class="btn btn-primary btn-block" (click)="applicaTimbro()" [disabled]="markForm.invalid">
          Salva
        </button>
      </div>
    </div>
  </div>
</form>